import * as React from "react"
import { PaymentInfo } from "./PaymentInfo"
import { PayingMember } from "./PayingMember"
import { observable, action } from "mobx"
import { PayStep } from "./PayStep"
import { OrderDetail } from "./OrderDetail"
import { Flex, Card } from "rebass"
import theme from "BookingSystem/theme"
import { BookingButton } from "BookingSystem/components/BookingButton"
import { observer } from "mobx-react"
import styled from "styled-components"

@observer
export class PayStepComp extends React.Component<{ model: PayStep }> {
  @observable.ref
  tokenize: any

  @action.bound
  async getCardToken() {
    const { model } = this.props
    if (!this.tokenize) {
      alert("You must be connected to the internet to pay for you booking")
      return
    }
    this.tokenize()
      .then(async (token: any) => {
        try {
          model.paymentProcessing = true
          await model.charge(token.token)
        } catch (error) {
          console.log(error)
          alert(
            "There was an error posting your transaction.  It has been sent to customer service."
          )
        } finally {
          model.paymentProcessing = false
        }
      })
      .catch((e: Error) => {
        alert("Please make sure your address and credit card info are correct.")
        console.error(e)
      })
  }

  render() {
    const { model } = this.props

    const StyledBookingButton = styled(BookingButton)`
      background-color: ${theme.colors.placeOrder};
    `

    const StyledCard = styled(Card)`
      background-color: ${theme.colors.white};
      color: ${theme.colors.black};
    `

    return (
      <Flex
        justifyContent="space-around"
        alignItems={["center", "flex-start"]}
        flexDirection={["column", "row"]}
        width={[1, 0.9, 0.8, 0.65]}
        id="pay-step-wrapper"
      >
        {model.paymentProcessing && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1000,
              height: "100vh",
              width: "100vw",
              background: "white",
              opacity: 0.65
            }}
          />
        )}
        <Flex
          id="left-pay-container"
          width={[0.99, 0.58]}
          flexDirection="column"
          justifyContent="center"
          alignItems={["center", "flex-end"]}
          mr={["1%"]}
          ml={["1%"]}
          mt={[0, "1%"]}
          mb={[0, "1%"]}
        >
          <StyledCard
            width={[0.99]}
            mr={["1%", "0%"]}
            ml={["1%"]}
            mt={["1%"]}
            mb={["1%"]}
            style={{
              padding: " 1.25rem",
              boxShadow: theme.shadows.smallPrimary
            }}
            className="customer-information"
          >
            <PayingMember model={model.order.member} flow={model.flow} />
          </StyledCard>
          <StyledCard
            width={[0.99]}
            mr={["1%", "0%"]}
            ml={["1%"]}
            mt={["1%"]}
            mb={["1%"]}
            style={{
              padding: " 1.25rem",
              boxShadow: theme.shadows.smallPrimary
            }}
            className="payment-information"
          >
            <PaymentInfo
              onTokenize={(tokenize: any) => {
                this.tokenize = tokenize
              }}
            />
          </StyledCard>
        </Flex>
        <Flex
          id="right-pay-container"
          width={[0.99, 0.42]}
          flexDirection="column"
          justifyContent={["flex-start", "center"]}
          alignItems={["center", "flex-start"]}
          mr={["1%"]}
          ml={["1%"]}
          mt={[0, "1%"]}
          mb={[0, "1%"]}
        >
          <StyledCard
            width={[0.99]}
            mr={["1%"]}
            ml={["1%", "0%"]}
            mt={["0%", "1%"]}
            mb={["1%"]}
            className="order-detail"
          >
            <OrderDetail model={model.order} />
          </StyledCard>
          <Flex
            alignItems="flex-start"
            justifyContent="center"
            width={[0.99]}
            mr={["1%", "0%"]}
            ml={["1%", "0%"]}
            mt={["0%", "1%"]}
            mb={["1%"]}
          >
            <StyledBookingButton
              width={[1]}
              onClick={() => {
                this.getCardToken()
              }}
              style={{ height: 50, backgroundColor: theme.colors.placeOrder }}
            >
              {model.paymentProcessing
                ? "...payment processing"
                : "Place Order"}
            </StyledBookingButton>
          </Flex>
        </Flex>
      </Flex>
    )
  }
}
